<template>
    <div class="projects-container px-12 lg:px-32 py-32">
      <h1 class="text-4xl font-bold mb-8">{{ $t('projects.title') }}</h1>
      
      <!-- Loop through each category -->
      <div v-for="(projects, category) in projectsByCategory" :key="category" class="category-section mb-12">
        <h2 class="text-2xl font-semibold mb-6 text-gray-700 dark:text-gray-300">{{ category }}</h2>
        
        <div class="projects-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <project-card 
            v-for="project in projects" 
            :key="project.id" 
            :project="project"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import ProjectCard from '@/components/ProjectCard.vue';
  
  export default {
    components: {
      ProjectCard
    },
    computed: {
      projectsList() {
        // Get all projects from the translations
        const projects = [];
        
        // Start with a reasonable number and check if projects exist
        let projectIndex = 1;
        let maxProjects = 10; // Set a reasonable limit
        
        while (projectIndex <= maxProjects) {
          const projectKey = `project${projectIndex}`;
          
          try {
            // Check if the project exists by trying to get its title
            const title = this.$t(`projects.${projectKey}.title`);
            
            // If the translation returns the key itself, it means the project doesn't exist
            if (title && title !== `projects.${projectKey}.title`) {
              const project = {
                id: projectIndex,
                title: title,
                description: this.$t(`projects.${projectKey}.description`),
                link: this.$t(`projects.${projectKey}.link`),
                image: this.getProjectImage(this.$t(`projects.${projectKey}.image`)),
                category: this.$t(`projects.${projectKey}.category`)
              };
              projects.push(project);
            } else {
              // No more projects found, stop looking
              break;
            }
          } catch (error) {
            console.warn(`Error loading project ${projectKey}:`, error);
            break;
          }
          
          projectIndex++;
        }
        
        console.log('Projects loaded dynamically:', projects); // Debug log
        return projects;
      },
      projectsByCategory() {
        // Group projects by category
        const grouped = {};
        
        this.projectsList.forEach(project => {
          const category = project.category;
          if (!grouped[category]) {
            grouped[category] = [];
          }
          grouped[category].push(project);
        });
        
        return grouped;
      }
    },
    methods: {
      getProjectImage(imageName) {
        if (!imageName || imageName === 'null' || imageName === null) {
          return null;
        }
        
        try {
          // Handle the esp.jpg specifically first
          if (imageName === 'esp.jpg') {
            return require('@/assets/projects/esp.jpg');
          }
          
          // Dynamically import other images from assets/projects folder
          return require(`@/assets/projects/${imageName}`);
        } catch (error) {
          console.warn(`Image not found: ${imageName}`);
          return null;
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .projects-container {
    min-height: 100vh;
  }
  </style>